import { render, staticRenderFns } from "./Detalle-vendedor.vue?vue&type=template&id=6ff1c96e&scoped=true"
import script from "./Detalle-vendedor.vue?vue&type=script&lang=js"
export * from "./Detalle-vendedor.vue?vue&type=script&lang=js"
import style0 from "./Detalle-vendedor.vue?vue&type=style&index=0&id=6ff1c96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff1c96e",
  null
  
)

export default component.exports